import React, { useEffect, useState } from 'react'
import {
  Box,
  Chip,
  Dialog,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useDebounce from "../../../Components/useDebounce/useDebounce";
import CustomSearch from '../../../Components/CustomSearch/CustomSearch';
import TableContainer from '../../../Components/TableContainer/TableContainer';
import { useDispatch } from 'react-redux';
import { GET_USERS_INTERPRETOR, USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION, USER_INTERPRETO_ACCOUNT_APPROVE_FIRST } from '../../../Redux/Slices/UserSlice/User.action';
import CheckIcon from "@mui/icons-material/Check";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import Constant from '../../../Utils/Constant';
import { useNavigate } from 'react-router-dom';
import CustomDropDown from '../../../Components/CustomDropDown/CustomDropDown';
import CustomTabPanel from '../../../Components/CustomTabs/CustomTabPanel';
import CustomTabs from '../../../Components/CustomTabs/Tabs';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import CustomSubmitButton from '../../../Components/CustomSubmitButton/CustomSubmitButton';
import { useFormik } from 'formik';
import CustomRejectInterpreter from '../../../Components/CustomRejectInterpreter/CustomRejectInterpreter';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
const UserManagement = () => {
  const pageSize = 15;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [usersList, setUsersList] = useState([]);
  const [userLanguageList, setUserLanguageList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const debouncedSearch = useDebounce(searchUser, 500);
  const [isRole, setIsRole] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [userId, setUserId] = useState(null);
  const [showRejectModel, setShowRejectModel] = useState(false);
  const isRoleList = [
    { name: "All", id: null },
    { id: 1, name: "Users", label: "Users" },
    { id: 2, name: "Interpreter", label: "Interpreter" },
  ];
  const columns = [
    {
      field: "action",
      headerName: "Actions",
      minWidth: 140,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { interpreter_verified, id } = params?.row;
        const actionButtons = [];
        if (activeTab !== 0) {
          if (interpreter_verified === 0) {
            actionButtons.push(
              <>
                <Tooltip title="Approve Request">
                  <IconButton
                    sx={{
                      background: "#4caf50",
                      width: "30px",
                      height: "30px",
                      borderRadius: "4px",
                      "&:hover": { background: "#388e3c" },
                    }}
                    onClick={() => handleInterPreterAccountStatusChange(id, 1, params)}
                  >
                    <CheckIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Reject Request">
                  <IconButton
                    sx={{
                      background: "red",
                      "&:hover": { background: "#c62828" },
                      width: "30px",
                      height: "30px",
                      borderRadius: "4px",
                    }}
                    onClick={() => handleInterPreterAccountRejectModel(id, -1)}
                  >
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Tooltip>
              </>
            );
          }
        }
        actionButtons.push(
          <Tooltip title="View" key="view">
            <IconButton
              onClick={() => {
                if (params?.row?.is_interpreter === 0) {
                  navigate(`/admin/user-details`, {
                    state: { id: id },
                  });
                } else {
                  navigate(`/admin/interpreter-details`, {
                    state: { id: id },
                  });
                }
              }
              }
              sx={{
                width: "30px",
                height: "30px",
                borderRadius: "4px",
                background:
                  "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                },
              }}
            >
              <RemoveRedEyeIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>)
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {actionButtons}
          </Box>
        );
      },
    },
    {
      field: "rowid",
      headerName: "Sr.No.",
      minWidth: 100,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      hideOnMobile: true,
      field: "profile_img",
      headerName: "Profile",
      minWidth: 50,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params?.row?.profile_img ? (
          <img
            src={`${Constant.BASE_URL}${params?.row?.profile_img}`}
            alt="profile_photo"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
            }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: "40px" }} />
        );
      },
    },
    {
      field: "full_name",
      headerName: "Full Name",
      minWidth: 250,
      filterable: true,
      sortable: true,
      renderCell: (params) => {
        const fullName = params?.row?.full_name || "--";
        return (
          <Tooltip title={fullName?.length > 25 ? fullName : ""}>
            <span>
              {fullName?.length > 25
                ? `${fullName?.substring(0, 25)}...`
                : fullName}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 300,
      hideOnMobile: true,
      renderCell: (params) => (
        <Tooltip title={params?.row?.email || "--"}>
          <span>{params?.row?.email || "--"}</span>
        </Tooltip>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      minWidth: 200,
      filterable: false,
      editable: false,
      sortable: false,
      hideOnMobile: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span>
          {params?.row?.phno_cc && params?.row?.phno
            ? `${params?.row?.phno_cc} ${params?.row?.phno}`
            : "--"}
        </span>
      ),
    },
    {
      field: "role",
      headerName: "User Type",
      minWidth: 150,
      filterable: false,
      editable: false,
      sortable: false,
      hideOnMobile: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        const role = params?.row?.is_interpreter || "--";
        return <Chip label={params?.row?.is_interpreter === 0 ? "User" : "Interpreter"} size="small" variant="outlined" sx={{
          border: params?.row?.is_interpreter === 0 ? "1px solid rgba(0, 151, 178, 1)" : "1px solid rgba(8, 85, 127, 1)",
          height: '36px',
          borderRadius: '10px',
          width: '117px',
          fontFamily: "Outfit",
          color: params?.row?.is_interpreter === 0 ? "rgba(0, 151, 178, 1)" : "rgba(8, 85, 127, 1)"
        }} />;
      },
    },

    {
      field: "is_premium",
      headerName: "Plan",
      minWidth: 220,
      filterable: false,
      editable: false,
      sortable: false,
      hideOnMobile: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        const type = params?.row?.premium_plan_type;

        let label = "Premium";
        let border = "#F9B600";
        let background = "#F9B600";
        let color = "#000";

        if (type === null || type === 0) {
          label = "Free";
          border = "1px solid rgba(0, 151, 178, 1)";
          background = "rgba(0, 151, 178, 0.1)";
          color = "rgba(0, 151, 178, 1)";
        } else if (type === 2) {
          label = "Plan assigned by admin";
          border = "1px solid #FF9900";
          background = "rgba(255, 153, 0, 0.1)";
          color = "#FF9900";
        }

        return (
          <Chip
            label={label}
            size="small"
            variant="outlined"
            sx={{
              border,
              background,
              color,
              height: '36px',
              borderRadius: '10px',
              width: '160px',
              fontFamily: "Outfit",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          />
        );
      }
    },

  ];
  if (activeTab !== 0 && activeTab !== 1) {
    const statusColumn = {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      filterable: false,
      editable: false,
      sortable: false,
      hideOnMobile: true,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { is_verified } = params?.row;
        return (
          <Chip
            label={"Rejected"}
            size="small"
            sx={{
              border: "1px solid rgba(208, 12, 0, 1)",
              height: "36px",
              background: "rgba(208, 12, 0, 1)",
              borderRadius: "10px",
              width: "117px",
              fontFamily: "Outfit",
              color: "#fff",
            }}
          />
        );
      },
    };
    columns.splice(columns.length - 1, 0, statusColumn);
  }
  useEffect(() => {
    getAllUsersList();
  }, [debouncedSearch, isRole, activeTab, page, dispatch]);
  const getAllUsersList = async () => {
    setIsLoading(true)
    await dispatch(GET_USERS_INTERPRETOR({ debouncedSearch, isRole, activeTab, page, pageSize })).unwrap()
      .then((res) => {
        if (res && res?.s === 1) {
          const Rowdata = res?.r?.map((data, i) => ({
            rowid: i + 1 + page * pageSize,
            ...data,
          }));
          setIsLoading(false)
          setUsersList(Rowdata);
          page === 0 && setCount(res?.total || 0);
        } else {
          setUsersList([]);
          setIsLoading(false)
        }
      }).catch((error) => {
        console.log('error', error);
        setIsLoading(false)
      })
  }
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleUpdateActiveUnVerifyBlockStatus = (id) => {
    setIsRole(id === null ? null : id);
    setPage(0);
  };
  const handleOnChangeStatus = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleInterPreterAccountStatusChange = async (userId, status, params) => {
    Swal.fire({
      title: 'Are you sure?',
      text: status === 1 ? 'Do you want to accept this request?' : "Do you want to reject this request",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (params?.row?.user_languages?.length > 0 && status === 1) {
          const formData = new FormData();
          formData.append("user_id", userId)
          const data = params?.row?.user_languages.map((language, index) => ({
            id: language?.id,
            commission: params?.row?.is_premium === 1 ? 20 : 30
          }));
          formData.append("commission", JSON.stringify(data));
          const res = await dispatch(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION(formData)).unwrap();
          if (res && res?.s === 1) {
            const userLanguageList = params?.row?.user_languages
            const approvalRes = await dispatch(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST({ userId, status, userLanguageList })).unwrap();
            for (const language of userLanguageList) {
              const certificates = language?.certificates || [];
              for (const cert of certificates) {
                const formDataCert = new FormData();
                formDataCert.append("certificate_id", cert.id);
                formDataCert.append("status", status);
                await AxiosInstance.post(`${APILIST.ADD_UPDATE_CERTIFICATE_REQUEST}/${cert.id}`, formDataCert);
              }
            }
            if (approvalRes && approvalRes?.s === 1) {
              toast.success("Request Approved Successfully!");
              getAllUsersList();
              setIsLoading(false);
            } else {
              toast.error(approvalRes?.m);
              setIsLoading(false);
            }
          }
        } else {
          toast.error("No languages found for this interpreter.");
        }
      }
    });
  };
  const handleInterPreterAccountRejectModel = (userId) => {
    if (userId) {
      setShowRejectModel(true);
      setUserId(userId);
    }
  }
  const handleSubmitAcceptReject = () => {
    getAllUsersList();
    setShowRejectModel(false);
    setUserId(null);
  }
  return (
    <>
      <Box
        sx={{
          width: "100%",
          bgcolor: "#fff",
          padding: '10px'
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
              User Management
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <CustomSearch
              placeholder="Search"
              value={searchUser}
              onChange={(event) => setSearchUser(event.target.value)}
              onClear={() => setSearchUser("")}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <CustomDropDown
              sx={{ height: "46px" }}
              placeholder={"Select Role"}
              menuList={isRoleList}
              value={isRole}
              onChange={(e) =>
                handleUpdateActiveUnVerifyBlockStatus(e.target.value)
              }
              getLabel={(item) => item?.name}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            width: "100%",
            paddingTop: "24px",
          }}
        >
          <CustomTabs tabValue={activeTab} onChange={handleOnChangeStatus} isRole={isRole} />
          <CustomTabPanel value={activeTab} index={0}>
            <TableContainer
              rows={usersList}
              columns={columns}
              pageSize={pageSize}
              loading={isLoading}
              page={page}
              totalCount={count}
              handlePageChange={handlePageChange}
              isPagination={true}
            />
          </CustomTabPanel>
          <CustomTabPanel value={activeTab} index={1}>
            <TableContainer
              rows={usersList}
              columns={columns}
              pageSize={pageSize}
              loading={isLoading}
              page={page}
              totalCount={count}
              handlePageChange={handlePageChange}
              isPagination={true}
            />
          </CustomTabPanel>
          <CustomTabPanel value={activeTab} index={2}>
            <TableContainer
              rows={usersList}
              columns={columns}
              pageSize={pageSize}
              loading={isLoading}
              page={page}
              totalCount={count}
              handlePageChange={handlePageChange}
              isPagination={true}
            />
          </CustomTabPanel>
        </Box>
      </Box>
      <CustomRejectInterpreter
        open={showRejectModel}
        onClose={() => setShowRejectModel(false)}
        userId={userId}
        handleOnClose={() => setShowRejectModel(false)}
        status={-1}
        handleSubmitAcceptReject={handleSubmitAcceptReject}
      />
    </>
  )
}

export default UserManagement;